<template>
  <v-dialog v-model="show" max-width="400px">
    <v-card>
      <v-card-title style="justify-content: center">{{ modalTitle }}</v-card-title>
      <v-card-text align="center" class="pt-2">
        {{ $t('order.currentDate') }}: {{ currentDeadline | moment('DD/MM/YYYY') }}
      </v-card-text>
      <v-card-text v-if="introductionSentence" align="center">{{ introductionSentence }}</v-card-text>
      <v-card-text align="center" :class="selectedDate ? '' : 'mb-10'">
        <v-date-picker
          v-model="selectedDate"
          :locale="locale"
          no-title
          :min="currentDeadline"
          :max="maxDate"
          :allowedDates="allowedDates"
          :picker-date.sync="pickerDate"
        ></v-date-picker>
      </v-card-text>
      <v-card-text v-if="selectedDate" align="center" class="new-date-height">
        {{ $t('order.selectedDate') }}: {{ selectedDate | moment('DD/MM/YYYY') }}
      </v-card-text>
      <v-card-actions class="pa-0">
        <v-btn :disabled="!selectedDate" color="primary" tile @click="validate()" style="width: 50%">
          {{ $t('subOrder.validate') }}
        </v-btn>
        <v-btn color="secondary" tile class="ml-0" style="width: 50%" @click="close()">
          {{ $t('subOrder.close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import moment from 'moment'

  export default {
    name: 'DateSelectionDialog',
    data() {
      return {
        selectedDate: undefined,
        pickerDate: null,
      }
    },
    props: {
      title: {
        type: String,
        default: undefined,
      },
      introductionSentence: {
        type: String,
        default: undefined,
      },
      value: {
        type: Boolean,
        default: false,
      },
      currentDeadline: {
        type: String,
        default: moment().format('YYYY-MM-DD'),
      },
      maxDate: {
        type: String,
        default: moment().add(7, 'days').format('YYYY-MM-DD'),
      },
      filterDateFunction: {
        type: Function,
        default: () => false,
      },
    },
    computed: {
      show: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        },
      },
      modalTitle: function () {
        if (!this.title) {
          return this.$t('components.modalMultipleChoices.defaultTitle')
        } else return this.title
      },
      locale() {
        return this.$i18n.locale
      },
    },
    mounted() {
      // Initialize pickerDate on mount
      if (this.value) {
        this.findFirstValidDate()
      }
    },
    watch: {
      value(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.findFirstValidDate()
          })
        } else {
          // Reset when dialog closes
          this.selectedDate = undefined
        }
      },
      currentDeadline() {
        // Re-find first valid date if currentDeadline changes
        if (this.value) {
          this.findFirstValidDate()
        }
      },
    },
    methods: {
      findFirstValidDate() {
        const startDate = moment(this.currentDeadline).startOf('day')
        const endDate = moment(this.maxDate).startOf('day')
        let currentDate = startDate.clone()

        // Iterate through each day to find the first valid date
        while (currentDate.isSameOrBefore(endDate, 'day')) {
          const dateStr = currentDate.format('YYYY-MM-DD')
          const isAllowed = this.allowedDates(dateStr)
          if (isAllowed) {
            // Set picker to the year-month of the first valid date
            this.pickerDate = currentDate.format('YYYY-MM')
            this.$forceUpdate()
            return
          }
          currentDate.add(1, 'day')
        }

        // If no valid date found, default to current deadline's month
        this.pickerDate = startDate.format('YYYY-MM')
        console.warn('No valid date found between', startDate.format('YYYY-MM-DD'), 'and', endDate.format('YYYY-MM-DD'))
        this.$forceUpdate()
      },
      validate: function () {
        this.$emit('validate', this.selectedDate)
        this.show = false
      },
      close: function () {
        this.$emit('close')
        this.show = false
      },
      allowedDates: function (val) {
        return this.filterDateFunction(val)
      },
    },
  }
</script>
<style scoped>
  .new-date-height {
    height: 40px !important;
  }
</style>
